/**
 * The one reader for a value a derivation records on a material's `userData` for its patches and
 * draw hooks to read back.
 */
/** The value `material` records under `key`, or `fallback` for a material that records none. */
export function recordedOn(material, key, fallback) {
    return material.userData[key] ?? fallback;
}
/**
 * A uniform that reads the value `material` records under `key` at each upload, so a re-parse that
 * changes only that value needs no recompile.
 */
export function recordedUniform(material, key, fallback) {
    return {
        get value() {
            return recordedOn(material, key, fallback);
        },
    };
}
//# sourceMappingURL=recordedOnMaterial.js.map